module.exports = { src: __webpack_public_path__ + "media/rentals-logo-vr.1ee11c44.svg", width: 215, height: 25 };